<div class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Rate Info</h5>
                <a class="close hover" (click)="close()">
                    <span aria-hidden="true">&times;</span>
                </a>
            </div>
            <div class="modal-body">


    <div class="ratePlanHolder">
        <div class="ratePlan" *ngFor="let ratePlan of ratePlans">
            <div class="corner-badge" *ngIf="ratePlan.planDiscount">
                <span>Best<br />value!</span>
            </div>
            <p class="fs-5 fs-regular">{{ratePlan.name}}</p>
            <p [innerHTML]="ratePlan.overview"></p>

            <ng-container *ngIf="!(profile$ | async)">
                <ng-container *ngIf="ratePlan.ratePlanCode !== 'BOB' && ratePlan.ratePlanCode !== 'BOP26' && ratePlan.ratePlanCode !== 'ESF2026'">
                    <p class="fs-5 fs-regular mb-0"> {{ratePlan.costs.costStandard.trueCostOfStay | currency: 'GBP'}}</p>
                    <p class="mb-1" style="font-style: italic; font-size: 13px;">Norfolk Passport price {{ratePlan.costs.costPassport.costOfStay | currency: 'GBP'}}</p>
                </ng-container>
                <ng-container *ngIf="ratePlan.ratePlanCode === 'BOB' || ratePlan.ratePlanCode === 'BOP26' || ratePlan.ratePlanCode === 'ESF2026'">
                    <p class="fs-5 fs-regular mb-0"> {{ratePlan.costs.costStandard.costOfStay | currency: 'GBP'}}</p>
                    <p *ngIf="ratePlan.tileOfferText && (availabilitySearch$ | async).nights < 2" class="mb-1" style="font-style: italic; font-size: 13px;">{{ratePlan.tileOfferText}}</p>
                </ng-container>

            </ng-container>

            <ng-container *ngIf="(profile$ | async)">
                <ng-container *ngIf="ratePlan.ratePlanCode !== 'BOB' && ratePlan.ratePlanCode !== 'BOP26' && ratePlan.ratePlanCode !== 'ESF2026'">
                    <p class="fs-5 fs-regular mb-0"><span class="was">{{ratePlan.costs.costStandard.trueCostOfStay | currency: 'GBP'}}</span> {{ratePlan.costs.costPassport.costOfStay | currency: 'GBP'}}</p>
                    <p class="mb-1" style="font-style: italic; font-size: 13px;">Saving {{ratePlan.costs.costPassport.discount | currency: 'GBP'}} with Norfolk Passport</p>
                </ng-container>
                <ng-container *ngIf="ratePlan.ratePlanCode === 'BOB' || ratePlan.ratePlanCode === 'BOP26' || ratePlan.ratePlanCode === 'ESF2026'">
                    <p class="fs-5 fs-regular mb-0">{{ratePlan.costs.costStandard.costOfStay | currency: 'GBP'}}</p>
                    <p *ngIf="ratePlan.tileOfferText && (availabilitySearch$ | async).nights < 2" class="mb-1" style="font-style: italic; font-size: 13px;">{{ratePlan.tileOfferText}} </p>
                </ng-container>

            </ng-container>


    </div>
</div>


            </div>
            </div>
            </div>
            </div>
<div class="modal-backdrop fade show modal-slide-show"></div>
